export default "__VITE_ASSET__CHb_jI0N__"